import { getCountries, getCountryCallingCode } from "libphonenumber-js";

export interface CountryCodeOption {
  name: string;
  code: string;
  dialCode: string;
  flag: string;
}

const regionNames =
  typeof Intl !== "undefined" && "DisplayNames" in Intl
    ? new Intl.DisplayNames(["en"], { type: "region" })
    : null;

const getFlagEmoji = (countryCode: string): string =>
  countryCode
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397));

const getCountryName = (countryCode: string): string =>
  regionNames?.of(countryCode) ?? countryCode;

export const countryCodes: CountryCodeOption[] = getCountries()
  .map((countryCode) => ({
    name: getCountryName(countryCode),
    code: countryCode,
    dialCode: `+${getCountryCallingCode(countryCode)}`,
    flag: getFlagEmoji(countryCode),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
